
import { DetailPusatResolusi } from "@/domain/entities/PusatResolusi";
import { prop, Vue, Options } from "vue-class-component";
import Accordion from "@/app/ui/components/accordion/index.vue";
import GuideCarouselModal from "./pop-up-carousel.vue";
import { FlagsPermissionPusatResolusiV2 } from "@/feature-flags/flags-pusat-resolusi-v2";

class Props {
  data = prop<DetailPusatResolusi>({
    required: true
  });
}

@Options({
  components: {
    Accordion,
    GuideCarouselModal
  }
})
export default class HowToReportCard extends Vue.with(Props) {
  activeTab = "shipping";
  showCarousel = false;
  selectedGuide: any = null;
  currentSlide = 0; // Add this line to declare the property

  openCarousel(guide: any) {
    this.selectedGuide = guide;
    this.showCarousel = true;
  }

  closeCarousel() {
    this.showCarousel = false;
    this.selectedGuide = null;
    this.currentSlide = 0;
  }

  nextSlide() {
    if (
      this.selectedGuide &&
      this.currentSlide < this.selectedGuide.carousel_list.length - 1
    ) {
      this.currentSlide++;
    }
  }

  prevSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
  }


  get contentGuideList() {
    try {
      const config = JSON.parse(
        FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_detail_tab_pengiriman.getValue()
      );
      return config.content_guide_list || [];
    } catch (error) {
      console.error("Error parsing content guide config:", error);
      return [];
    }
  }

  get contentGuideListSystem() {
    try {
      const config = JSON.parse(
        FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_detail_tab_sistem.getValue()
      );
      return config.content_guide_list || [];
    } catch (error) {
      console.error("Error parsing content guide config:", error);
      return [];
    }
  }
}
